enum RouteDestination {
  DASHBOARD = '/dashboard',
  COMMUNICATIONS = '/communications',
  ACCOUNTING = '/accounting',
  PROPERTIES = '/properties',
  LEASES = '/leases',
  TEMPLATES = '/settings/templates',
  CONTACTS = '/contacts',
  TICKETS = '/issues',
  TICKETS_DETAILS = '/issueDetail',
  ADD_PROPERTY = '/addProperty',
  EDIT_PROPERTY = '/editProperty',
  ADD_UNIT = '/addUnit',
  EDIT_UNIT = '/editUnit',
  ADD_LEASE = '/addLease',
  EDIT_LEASE = '/editLease',
  ADD_TECHNIC = '/addTechnic',
  EDIT_TECHNIC = '/editTechnic',
  PROPERTIES_TECHNICS = '/properties/technics',
  ADD_CHARGE = '/addCharge',
  AFFECT_CHARGE = '/affectCharge',
  CHARGE_SUMMARY = '/chargeSummary',
  IMPORT_RUN = '/importRun',
  SETTINGS = '/settings',
  ADD_TICKET = '/addIssue',
  EDIT_ADVERTISEMENT = '/editAdvertisement',
  RECONCILE_TRANSACTION = '/reconciliation',
  VALIDATE_TENANT_STATEMENT = '/validateTenantTransaction',
  VALIDATE_OWNER_STATEMENT = '/validateOwnerTransaction',
  EDIT_SIGNATURES = '/editSignatures',
  INDEXATION = '/indexation',
  PONTO_CALLBACK = '/pontoConnect',
  MICROSOFT_CALLBACK = '/microsoftConnect',
  GOOGLE_CALLBACK = '/googleConnect',
  PAYMENT_MANDATE_CALLBACK = '/mandateResponse',
  STRIPE_MANDATE_ACTIVATED = '/mandateActivated',
  DOCUMENTS = '/documents',
  SIGNATURES = '/signatures',
  MY_COMPANY = '/myCompany',
  NEW_INVOICE = '/newInvoice',
  LEASE_INVOICE_DETAIL = '/leaseInvoiceDetail',
  EXACT_ONLINE = '/exactOnline',
  INTEGRATIONS_DETAILS = '/settings/integrations/details',
  ANNOUNCEMENTS = '/announcements',
  RENT_TRACKING = '/rent-tracking',
  ROOT = '/',
  ACCEPT_INVITATION = '/accept-invitation',
  RESET_PASSWORD = '/reset-password',
  VERIFY_PHONE = '/verify-phone',
}
export default RouteDestination;
